import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-body justify-content-center align-items-middle d-flex flex-column text-center overflow-hidden" }
const _hoisted_3 = { class: "fs-1 mb-2" }
const _hoisted_4 = { class: "scholarship-stack" }
const _hoisted_5 = { class: "scholarship-stack" }
const _hoisted_6 = { class: "scholarship-stack" }
const _hoisted_7 = { class: "small d-flex flex-column overflow-hidden" }
const _hoisted_8 = { class: "small" }
const _hoisted_9 = { class: "text-nowrap" }
const _hoisted_10 = { class: "text-nowrap" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "text-nowrap" }
const _hoisted_13 = { class: "small d-flex flex-column overflow-hidden" }
const _hoisted_14 = { class: "small" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[9] || (_cache[9] = _createElementVNode("h6", { class: "card-header text-nowrap" }, [
      _createElementVNode("i", { class: "fas fa-piggy-bank me-2" }),
      _createTextVNode("Beca GTR Evolution")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      (
          !_ctx.isAcademyAndLicenseActive ||
          _ctx.accountSummary?.scholarshipEndDate === undefined ||
          _ctx.accountSummary?.scholarshipEndDate < new Date()
        )
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _cache[0] || (_cache[0] = _createElementVNode("div", { class: "fs-1 mb-2" }, [
              _createElementVNode("i", { class: "fas fa-lock fa-lg mx-2" })
            ], -1)),
            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "small d-flex flex-column overflow-hidden" }, [
              _createElementVNode("span", { class: "small" }, [
                _createTextVNode("Necesitas estar suscrito a la "),
                _createElementVNode("strong", null, "Academia Virtual"),
                _createTextVNode(" y contar con tu "),
                _createElementVNode("strong", null, "Licencia de Distribuidor"),
                _createTextVNode(" para poder comenzar a calificar para tu Beca.")
              ])
            ], -1))
          ], 64))
        : (_ctx.accountSummary?.scholarshipPoints < 300)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("span", _hoisted_4, [
                  (
                _ctx.accountSummary.scholarshipPoints > 0 &&
                _ctx.accountSummary.scholarshipPoints < 100
              )
                    ? (_openBlock(), _createElementBlock("i", {
                        key: 0,
                        class: _normalizeClass([_ctx.scholarshipPointsClass(100), "text-orange"])
                      }, null, 2))
                    : _createCommentVNode("", true),
                  _createElementVNode("i", {
                    class: _normalizeClass(_ctx.scholarshipPointsClass(100)),
                    style: _normalizeStyle(_ctx.scholarshipPartialPercentageStyle(100))
                  }, null, 6)
                ]),
                _createElementVNode("span", _hoisted_5, [
                  (
                _ctx.accountSummary.scholarshipPoints > 100 &&
                _ctx.accountSummary.scholarshipPoints < 200
              )
                    ? (_openBlock(), _createElementBlock("i", {
                        key: 0,
                        class: _normalizeClass([_ctx.scholarshipPointsClass(200), "text-orange"])
                      }, null, 2))
                    : _createCommentVNode("", true),
                  _createElementVNode("i", {
                    class: _normalizeClass(_ctx.scholarshipPointsClass(200)),
                    style: _normalizeStyle(_ctx.scholarshipPartialPercentageStyle(200))
                  }, null, 6)
                ]),
                _createElementVNode("span", _hoisted_6, [
                  (
                _ctx.accountSummary.scholarshipPoints > 200 &&
                _ctx.accountSummary.scholarshipPoints < 300
              )
                    ? (_openBlock(), _createElementBlock("i", {
                        key: 0,
                        class: _normalizeClass([_ctx.scholarshipPointsClass(300), "text-orange"])
                      }, null, 2))
                    : _createCommentVNode("", true),
                  _createElementVNode("i", {
                    class: _normalizeClass(_ctx.scholarshipPointsClass(300)),
                    style: _normalizeStyle(_ctx.scholarshipPartialPercentageStyle(300))
                  }, null, 6)
                ])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("span", _hoisted_8, [
                  _cache[2] || (_cache[2] = _createTextVNode("Para calificar tu ", -1)),
                  _cache[3] || (_cache[3] = _createElementVNode("strong", null, "Beca", -1)),
                  _cache[4] || (_cache[4] = _createTextVNode(" necesitas activar: ", -1)),
                  _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1)),
                  _createElementVNode("span", _hoisted_9, [
                    _createElementVNode("strong", null, "(" + _toDisplayString(_ctx.basicAffiliatesNeededForScholarship) + ")", 1),
                    _createTextVNode(" " + _toDisplayString(_ctx.localizedAffiliate(_ctx.basicAffiliatesNeededForScholarship)) + " Básico/VIP ó", 1)
                  ]),
                  _createElementVNode("span", _hoisted_10, [
                    _createElementVNode("strong", null, " (" + _toDisplayString(_ctx.liteAffiliatesNeededForScholarship) + ")", 1),
                    _createTextVNode(" " + _toDisplayString(_ctx.localizedUpgrade(_ctx.liteAffiliatesNeededForScholarship)) + " de Lite a Básico", 1)
                  ]),
                  (_ctx.accountSummary.scholarshipPoints < 200)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_11, " ó alguna combinación de ambos"))
                    : _createCommentVNode("", true),
                  _cache[6] || (_cache[6] = _createTextVNode(", antes de: ", -1)),
                  _createElementVNode("strong", _hoisted_12, _toDisplayString(_ctx.scholarshipEndDate), 1)
                ])
              ])
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _cache[8] || (_cache[8] = _createElementVNode("div", { class: "fs-1 mb-2" }, [
                _createElementVNode("i", { class: "fas fa-award text-yellow fa-lg" })
              ], -1)),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("span", _hoisted_14, [
                  _cache[7] || (_cache[7] = _createTextVNode("Muchas Felicidades por obtener tu Beca. Este periodo finaliza el: ", -1)),
                  _createElementVNode("strong", null, _toDisplayString(_ctx.scholarshipEndDate), 1)
                ])
              ])
            ], 64))
    ])
  ]))
}